import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { ConformComponent } from '../../conform/conform.component';
import { JwtService, PatientService, ShowHideInput, User, UserService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'createnewpassword.component.html',
  styleUrls: ['../style.component.css']
})
export class CreatenewpasswordComponent implements OnInit {
  forgotlink: boolean;
  patdetails: any;
  public data: Object;
  modalRef: BsModalRef;
  @ViewChild(ShowHideInput) input: ShowHideInput;
  public params: any;
  public pasd: any = {};
  newonepassword = '';
  newtwopassword = '';
  errormsgpass = '';
  public carepath: any = {};
  public myobj1: any = {};
  apiurl = environment.api_url;
  public Patp: any = {
    newpass: "",
    newpass2: ""
  };
  passval: boolean = false;
  passval1: boolean = false;
  passval2: boolean = false;
  passval3: boolean = false;
  passval4: boolean = false;
  passkey: boolean = false;
  passkey1: boolean = false;
  passkey2: boolean = false;
  passkey3: boolean = false;
  passkey4: boolean = false;
  passwordTyoe: boolean = false;
  password: any;
  patvalue: any = {};
  resdata: any;
  show: any;
  pattern: any = "(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z*$-+?_&=!#@%{}/'.]*$";
  userGroup: boolean = false;
  public selectques = [];
  public selectques1 = [];
  currentUser: User
  public Select = {
    quest1: "",
    quest2: "",
    quest3: "",
    answer1: "",
    answer2: "",
    answer3: ""
  }
  patid: any;
  welcome: any;


  expires: MatDialogRef<ConformComponent>;
  public myobj: any = {};

  showAndroid: boolean = false;
  stepAndroid: boolean;
  question: any = [];
  resetdata: string;
  userpass: any;
  useremail: any;
  patswfid: any;
  invalidpass: string;
  constructor(
    private activeroute: ActivatedRoute,
    private routers: Router,
    private patientservice: PatientService,
    private modalService: BsModalService,
    private jwtService: JwtService,
    private userService: UserService,
    private dialog: MatDialog,
    private toast: ToastrService,
    private nav: Router,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(userService.defaultLang);
  }

  ngOnInit() {
    if (navigator.userAgent.search("Android") != -1) {
      this.showAndroid = true;
      this.stepAndroid = false;
    }

    this.patientservice.changeNav(window.localStorage['randId'])
    this.patid = window.localStorage['randId']
    if (window.localStorage['status'] != 'forgotlink') {
      this.patientservice
        .getwelcomepat(window.localStorage['randId'])
        .subscribe(
          data => {
            //////console.log(data);
            if (data.status != 'failure') {
              this.patdetails = data
              if (data.userGroupId == 19 || data.userGroupId == 20) {
                this.userGroup = false
                this.pattern = "(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z*$-+?_&=!#@%{}/'.]*$"
              } else {
                this.userGroup = true
                this.pattern = '(?=^.{8,32}$)((?!.*\s)(?=.*[A-Z])(?=.*[a-z]))((?=(.*\d){1,})|(?=(.*\W){1,}))^.*$'
              }

            } else {
              this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
            }
          })
      this.patientservice
        .getquestions()
        .subscribe(
          data => {

            //////console.log(data);
            if (data) {

              this.question = data;
            }
            else {


            }
          }
        );
    } else {
      if (window.localStorage['mail']) {
        this.userService.forgotUserInfo(window.localStorage['mail'])
          .subscribe(
            data => {
              if (data) {
                this.forgotlink = true
                this.patdetails = data;
                this.patdetails.patientName = data.firstName + ' ' + data.lastName;
                this.patdetails.email = this.patdetails.userName
                if (data.userGroupId == 19 || data.userGroupId == 20) {
                  this.userGroup = false
                  this.pattern = "(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z*$-+?_&=!#@%{}/'.]*$"
                } else {
                  this.userGroup = true
                  this.pattern = '(?=^.{8,32}$)((?!.*\s)(?=.*[A-Z])(?=.*[a-z]))((?=(.*\d){1,})|(?=(.*\W){1,}))^.*$'
                }
              } else {
                this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
              }
            })
      }
    }

    if (window.localStorage['pwd']) {
      this.carepath = JSON.parse(window.localStorage['pwd']);
      this.myobj = JSON.stringify(this.carepath);
      ////console.log("care",this.carepath.userEmail)
    }
    else {
      //this.routers.navigate([`/login`]) 
    }
    /*   this.password=this.params.carepath;
      if(this.password == "true"){
      if(window.localStorage['pwd']){
      this.carepath = JSON.parse( window.localStorage['pwd']);
      this.myobj1 = JSON.stringify(this.carepath);
      ////console.log("care",this.carepath.userFnLn)
      }
      else{
       this.routers.navigate([`/login`]) 
      }
      }  */
  }

  useAccountId: any;
  ques(qa, passchange) {
    let patvalue = {
      "randId": window.localStorage['randId'],
      "newpswd": qa.value.newpass ? qa.value.newpass : this.Patp.newpass,
      "activationMode": window.localStorage['firsttimeuser'] == 1 ? 'F' : 'M'
    }
    this.jwtService.patpwd(JSON.stringify(patvalue));
    if ((qa.value.newpass == qa.value.newpass2) || (this.Patp.newpass == this.Patp.newpass2)) {
      this.userpass = btoa(qa.value.newpass)
      this.patientservice.lastpass(this.patdetails.userAccountId ? this.patdetails.userAccountId : this.patdetails.userId, qa.value.newpass)
        .subscribe(
          data => {
            if (data.status != 'failure') {
              this.patientservice.passchange(patvalue)
                .subscribe(
                  data => {

                    this.jwtService.pwdupdate(JSON.stringify(data));
                    this.useremail = data.userEmail
                    this.useAccountId = data.userAccountId
                    ////console.log(this.userpass,this.useremail)
                    if (data) {
                      this.patientservice.pwdHistroy(data.userAccountId ? data.userAccountId : this.patdetails.userId, qa.value.newpass)
                        .subscribe(data => { })
                      this.resetdata = "Success";
                      let ans = {
                        //"userAccountId": this.patid,
                        "secQuestionOne": qa.value.quest1 ? qa.value.quest1 : '',
                        "secQuestionTwo": qa.value.quest2 ? qa.value.quest2 : '',
                        "secQuestionThree": qa.value.quest3 ? qa.value.quest3 : '',
                        "secQusAnswerOne": qa.value.answer1 ? qa.value.answer1 : '',
                        "secQusAnswerTwo": qa.value.answer2 ? qa.value.answer2 : '',
                        "secQusAnswerThree": qa.value.answer3 ? qa.value.answer3 : '',
                        "activationMode": window.localStorage['firsttimeuser'] == 1 ? 'F' : 'M'
                      }
                      let activate = false
                      if (window.localStorage['status'] != 'forgotlink')
                        activate = true
                      this.patientservice
                        .getquesti(ans, window.localStorage['randId'], activate)
                        .subscribe(
                          data => {
                            if (data.status == 'Success' && data.message == 'Profile' && window.localStorage['status'] != 'forgotlink') {
                              if (this.myobj.userGroupId == 19 || this.myobj.userGroupId == 20) {
                                this.toast.success(this.userService.translateText('patient_portal.display_messages.security_ques_setup.success'))
                                this.routers.navigate([`/thankyou`])
                              }
                              else {
                                this.toast.success(this.userService.translateText('patient_portal.display_messages.password_setup.success'))
                                this.routers.navigate([`/thankyou`])
                              }
                            }
                            else if (data.status == 'Success' && (data.message == 'Dashboard' || window.localStorage['status'] == 'forgotlink')) {
                              this.toast.success(this.userService.translateText('patient_portal.display_messages.password_setup.success'))
                              let credentials = {
                                'username': this.useremail,
                                'password': this.userpass,
                                'captcha': '',
                                'mode': '',
                                'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'p',
                                'forcelogin': 'false'
                              }
                              this.userService.attemptAuth(credentials)
                                .subscribe(
                                  data => {
                                    if (data.operationStatus == "SUCCESS") {
                                      if (this.currentUser.item.userAccountId == 19 || this.currentUser.item.userAccountId == 20) {
                                        this.userService.postuserinfoid(1, this.currentUser.item.userAccountId).subscribe(
                                          data => {
                                            this.patswfid = data[0].patientStageWorkflow[0].patSWFId
                                          }
                                        )
                                        this.routers.navigate(['/patient/dashboard/' + btoa(this.patswfid)])
                                      }
                                    }
                                  })
                            }

                            else {
                              this.toast.error(this.userService.translateText('patient_portal.display_messages.invalid_data.error'))
                            }
                          }
                        )
                    }
                    else {
                      this.resdata = data.message;
                      this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
                    }


                  })
            }
            else {
              this.resdata = this.userService.translateText('patient_portal.display_messages.something_went_wrong');
              this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
            }


          })

    }
    else {
      this.resdata = this.userService.translateText('patient_portal.validations.confirm_pwd_does_not_match.error');
      this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
    }


    /* if(this.resetdata == "Success"){
      
        ////console.log(qa.value)
        qa.value.newpass
        qa.value.newpass2
        let ans={
          
          "secQuestionOne": qa.value.quest1,
          "secQuestionTwo": qa.value.quest2,
          "secQuestionThree": qa.value.quest3,
          "secQusAnswerOne": qa.value.answer1,
          "secQusAnswerTwo": qa.value.answer2,
          "secQusAnswerThree": qa.value.answer3
        }
        ////console.log(ans)
        
        this.patientservice
        .getquesti(ans,this.patid)
        .subscribe(
          data =>
          {
            ////console.log(data)
            ////console.log("userid",this.myobj.userGroupId)
             if(data == true){
              if(this.myobj.userGroupId == 19 || this.myobj.userGroupId == 20){
                this.toast.success("Security questions saved successfully")
            
            this.routers.navigate([`/upload`])    
          }
              else{
                this.toast.success("Security questions saved successfully")
           
               this.routers.navigate([`/upload`])
              }
            
             }
            else {
             this.toast.error("INVALID DATA")
            }
          }
        )
        } */
  }

  getuniquelist(event) {

    this.selectques = _.reject(this.question, (o: any): any => {
      return o.userSecQuestionsId == event
    })

    ////console.log(this.selectques)
  }
  getlist(event) {

    this.selectques1 = _.reject(this.selectques, (o: any): any => {
      return o.userSecQuestionsId == event
    })

    ////console.log(this.selectques1)
  }
  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }
  focus(event, id) {
    if (event) {
      $(`#${id}`).addClass('shown')
    }

  }
  outfocus(event, id) {
    if (event) {
      $(`#${id}`).removeClass('shown')
    }

  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  checkPwd(pas) {
    if (pas.target.value) {
      this.patientservice.chkPass(pas.target.value)
        .subscribe(
          data => {
            if (data[0].status == 'failure') {
              this.Patp.newpass = '';
              this.Patp.newpass2 = '';
              this.toast.error(data[0].message)
            }
          })
    }
  }
  passwordmatch(pas, passchange) {
    // ////console.log(pas.value.newpass)
    let patvalue = {
      "randId": window.localStorage['randId'],
      "newpswd": pas.value.newpass
    }
    if (pas.value.newpass == pas.value.newpass2) {
      this.patientservice.lastpass(this.patdetails.userAccountId ? this.patdetails.userAccountId : this.patdetails.userId, pas.value.newpass)
        .subscribe(
          data => {
            if (data.status != 'failure') {
              this.patientservice.passchange(patvalue)
                .subscribe(
                  data => {
                    //this.jwtService.pwdupdate(JSON.stringify(data));
                    if ((data.message.toLowerCase()) == 'true') {
                      this.patientservice.pwdHistroy(data.userAccountId ? data.userAccountId : this.patdetails.userId, pas.value.newpass)
                        .subscribe(data => { })
                      this.userService.logAudit('getUserPassWordUpdate', 0).subscribe(data => { })
                      this.routers.navigate([`/questions`])
                    }
                    else {
                      this.resdata = this.userService.translateText('patient_portal.display_messages.something_went_wrong');
                      this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
                    }


                  })
            } else {
              this.resdata = data.message;
              this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
            }
          })

    }

    else {
      this.resdata = this.userService.translateText('patient_portal.validations.confirm_pwd_does_not_match.error');
      this.modalRef = this.modalService.show(passchange, { class: 'modal-sm', backdrop: 'static' });
    }
  }
  modal() {

    this.routers.navigate([`/upload`])
  }

  onKey(event: any) {
    var letters = /[a-z,A-Z]/g;
    var lowerCaseLetters = /[a-z]/g;
    var upperCaseLetters = /[A-Z]/g;
    var numbers = /[0-9]/g;
    var special = /[#$^+=!*()@%&]/g;
    if (event.target.value.match(lowerCaseLetters)) {
      this.passval = true
    }
    else {
      this.passval = false
    }
    if (!this.userGroup) {
      if (event.target.value.match(letters)) {
        this.passval1 = true
      }
      else {
        this.passval1 = false
      }
    } else {
      if (event.target.value.match(upperCaseLetters)) {
        this.passval1 = true
      }
      else {
        this.passval1 = false
      }
    }
    if (event.target.value.match(numbers)) {
      this.passval2 = true
    }
    else {
      this.passval2 = false
    }
    if (event.target.value.length >= 8) {
      this.passval3 = true
    }
    else {
      this.passval3 = false
    }
    if (event.target.value.match(special)) {
      this.passval4 = true
    }
    else {
      this.passval4 = false
    }

  }
  onKey1(event: any) {
    var letters = /[a-z,A-Z]/g;
    var lowerCaseLetters = /[a-z]/g;
    var upperCaseLetters = /[A-Z]/g;
    var numbers = /[0-9]/g;
    var special = /[#$^+=!*()@%&]/g;
    if (event.target.value.match(lowerCaseLetters)) {
      this.passkey = true
    }
    else {
      this.passkey = false
    }
    if (!this.userGroup) {
      if (event.target.value.match(letters)) {
        this.passkey1 = true
      }
      else {
        this.passkey1 = false
      }
    }
    else {
      if (event.target.value.match(upperCaseLetters)) {
        this.passkey1 = true
      }
      else {
        this.passkey1 = false
      }
    }
    if (event.target.value.match(numbers)) {
      this.passkey2 = true
    }
    else {
      this.passkey2 = false
    }
    if (event.target.value.length >= 8) {
      this.passkey3 = true
    }
    else {
      this.passkey3 = false
    }
    if (event.target.value.match(special)) {
      this.passkey4 = true
    }
    else {
      this.passkey4 = false
    }


  }



  getValidationLink(randId) {
    this.userService.getValidationLink(randId)
      .subscribe(data => {
        if (data.status == 'fail') {
          this.expires = this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
          this.expires.componentInstance.message = data.message;
          this.ngOnDestroy()
        }
      })
  }

  ngOnDestroy() {
    this.params = "";
  }
}






